import { render, staticRenderFns } from "./swipeDialog.vue?vue&type=template&id=f22dab9a&scoped=true"
import script from "./swipeDialog.vue?vue&type=script&lang=js"
export * from "./swipeDialog.vue?vue&type=script&lang=js"
import style0 from "./swipeDialog.vue?vue&type=style&index=0&id=f22dab9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22dab9a",
  null
  
)

export default component.exports